import i18n from '@/shared/i18n';
import { getApiErrorDetails } from '@/shared/utils/apiError';
import type { ImportCsvErrorRow } from './ImportCsvDialog';

export const getImportFileErrorMessage = (err: unknown, fallback: string): string => {
  const details = getApiErrorDetails(err, fallback);
  if (!details.code) return details.message;
  return String(
    i18n.t(`common:importExport.errors.${details.code}`, {
      defaultValue: details.message,
      ...(details.data ?? {}),
    })
  );
};

export const formatImportRowError = (
  error: ImportCsvErrorRow,
  rowErrorsPrefix: string
): string => {
  if (!error.errorCode) return error.message;
  return String(
    i18n.t(`${rowErrorsPrefix}.${error.errorCode}`, {
      defaultValue: error.message,
      ...(error.params ?? {}),
    })
  );
};
